/**
 * Analyze Options Lesson
 * Skill Area: Operations
 * Evaluate program choices with evidence
 */

import type { LessonDefinition } from '../types';
import { ANALYZE_OPTIONS_AI_PROMPT } from '../prompts/analyze-options.prompt';

export const analyzeOptions: LessonDefinition = {
  id: 'analyze-options',
  title: 'Analyze Options',
  displayTitle: 'Evaluate Program Choices with Evidence',
  subTitle: 'Evaluate program choices with AI',
  persona: 'Lyra',
  skillArea: 'Operations',
  topicId: 'programs-projects',
  topicTitle: 'Programs & Projects',
  topicDescription: 'Analyze options, build plans, monitor finances, and balance team workload.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 8,
  tags: ['analysis', 'decision-making', 'programs'],
  dailyEligible: true,
  releasedAt: '2025-01-20T00:00:00.000Z',
  route: '/micro/analyze-options',
  storyBeat: 'Make confident, evidence-based program choices.',
  introPrompt: "Decisions drag on when you rely on gut feelings. One wrong program choice can waste months of work. Let's fix that.",
  steps: [
    "Identify where evidence gaps cause the most decision paralysis",
    "Learn the Evidence Evaluation framework",
    "Practice spotting weak evidence in realistic options",
    "Master your personalized evaluation checklist"
  ],
  promptGuidance: 'Choose a decision type below or type your own.',
  aiPrompt: ANALYZE_OPTIONS_AI_PROMPT,
  inputPlaceholder: "e.g., Program expansion decisions...",
  quickPrompts: [
    'Program expansion vs. new initiative',
    'Vendor or partner selection',
    'Grant opportunity prioritization',
    'Pilot program scaling decisions'
  ]
};
